export default "/packages/crypto-currency-images/png/fallback.png"